import axios from 'axios'
import ConfigConstants from '@/constants/Config.constants'
import { IGlobalFilterService } from '@/services/IGlobalFilterService'
import { Response, GlobalFilter } from '@/models'

export default class GlobalFiltersService implements IGlobalFilterService {
  private endpointUrl: string

  private readonly options = {
    headers: {
      'Content-Type': ConfigConstants.CONTENT_TYPES.YT_V1,
      Accept: '*/*',
    },
  } as const

  constructor(endpointUrl: string) {
    this.endpointUrl = endpointUrl
  }

  public async getGlobalFilters(projectId: number): Promise<GlobalFilter[]> {
    return axios
      .get<
        Response<GlobalFilter[]>
      >(`${this.endpointUrl}/project/${projectId}/filter`, this.options)
      .then((response) => response.data.data)
  }

  public async createGlobalFilter(
    projectId: number,
    globalFilter: Omit<GlobalFilter, 'id'>,
  ): Promise<GlobalFilter> {
    return axios
      .post<
        Response<GlobalFilter>
      >(`${this.endpointUrl}/project/${projectId}/filter`, { data: globalFilter }, this.options)
      .then((response) => response.data.data)
  }

  public async getGlobalFilterById(
    projectId: number,
    globalFilterId: number,
  ): Promise<GlobalFilter | undefined> {
    return axios
      .get<
        Response<GlobalFilter>
      >(`${this.endpointUrl}/project/${projectId}/filter/${globalFilterId}`, this.options)
      .then((response) => response.data.data)
  }

  public async updateGlobalFilter(
    projectId: number,
    globalFilter: GlobalFilter,
  ): Promise<GlobalFilter> {
    return axios
      .put<
        Response<GlobalFilter>
      >(`${this.endpointUrl}/project/${projectId}/filter/${globalFilter.id}`, { data: globalFilter }, this.options)
      .then((response) => response.data.data)
  }

  public async deleteGlobalFilter(
    projectId: number,
    globalFilterId: number,
  ): Promise<GlobalFilter> {
    return axios
      .delete<
        Response<GlobalFilter>
      >(`${this.endpointUrl}/project/${projectId}/filter/${globalFilterId}`, this.options)
      .then((response) => response.data.data)
  }
}
